"use strict";

var RegExpHelper = {
	getCalcExpression: function (value) {
		// See https://developer.mozilla.org/en-US/docs/Web/CSS/calc
		// regex originally from https://codepen.io/benfoster/pen/VPjLdQ
		return value.match(/calc\(( )?([\d\.]+(%|vh|vw|vmin|vmax|em|rem|px|cm|ex|in|mm|pc|pt|ch|q|deg|rad|grad|turn|s|ms|hz|khz))( )+[+\-\*\/]( )+(\-)?([\d\.]+(%|vh|vw|vmin|vmax|em|rem|px|cm|ex|in|mm|pc|pt|ch|q|deg|rad|grad|turn|s|ms|hz|khz))( )?\)/i);
	},

	getColorName: function (value) {
		return value.match(/^[a-z]{3,}$/i);
	},

	getCSSLength: function (value) {
		return value.match(/-*\d+([a-z]{2,4}|%)/ig);
	},

	getHexColor: function (value) {
		if (value.length === 7) {
			return value.match(/#([a-f0-9]{6})/i);
		} else if (value.length === 4) {
			return value.match(/#([a-f0-9]{3})/i);
		} else {
			return null;
		}
	},

	getRgbColor: function (value) {
		return value.match(/rgb\((\d{1,3}), *(\d{1,3}), *(\d{1,3})\)/i);
	},

	getRgbaColor: function (value) {
		return value.match(/rgba\((\d{1,3}), *(\d{1,3}), *(\d{1,3}), *(0\.\d{1,}|\.\d{1,}|0|1)\)/i);
	},

	getEndingScriptTags: function (value) {
		return value.match(/<\/script>/ig);
	},

	getMatchingScriptTags: function (value) {
		return value.match(/<script[^>]*>[^<]*<\/script>/ig);
	},

	getStartingScriptTags: function (value) {
		return value.match(/<script[^>]*>/ig);
	},

	isCalcExpression: function (value) {
		return RegExpHelper.getCalcExpression(value) ? true : false;
	},

	isColorName: function (value) {
		//validates that the value is in the color name format, not that it is a valid CSS color name
		return RegExpHelper.getColorName(value) ? true : false;
	},

	isCSSLength: function (value) {
		return RegExpHelper.getCSSLength(value) ? true : false;
	},

	isCSSNumber: function (value) {
		//see https://developer.mozilla.org/en-US/docs/Web/CSS/number#Interpolation
		//A regex to validate CSS number formats is unnecessary as the following tests suffice:
		if (value === null || value === "") {
			return false;
		}

		if (!isNaN(+value)) {
			// "12." is a valid number, but not a valid CSS number
			if (typeof value === "string" && value[value.length - 1] === ".") {
				return false;
			}
			return true;
		}

		return false;
	},

	isCSSURL: function (value) {
		//supports both absolute and relative url paths
		return /^(http|https):\/\/[^ "]+$|^[^ "]+$/.test(value);
	},

	isHexColor: function (value) {
		return RegExpHelper.getHexColor(value) ? true : false;
	},

	isRgbColor: function (value) {
		return RegExpHelper.getRgbColor(value) ? true : false;
	},

	isRgbaColor: function (value) {
		return RegExpHelper.getRgbaColor(value) ? true : false;
	},

	isAlphaNumeric: function (value) {
		return value === undefined || value === null ? false : /^[a-z0-9]+$/i.test(value);
	},

	isNumeric: function (value) {
		return value === undefined || value === null ? false : /^[0-9]+$/i.test(value);
	},

	// If value is "/countries/{countryName}/states", the "{countryName}" will be replaced with model.countryName
	replaceFirstBraceTokenFromObject: function (value, model) {
		var braceTokenMatchRegularExpression = /.*\{(.+)\}.*/;
		var braceTokenReplaceRegularExpression = /\{(.+)\}/;

		var matchArray = braceTokenMatchRegularExpression.exec(value);
		if (matchArray[1]) {
			value = value.replace(braceTokenReplaceRegularExpression, model[matchArray[1]]);
		}
		return value;
	}
};

module.exports = RegExpHelper;